import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../reducers/modalReducer';
import {
  isSalesChannelActive,
  isSalesChannelFulfillmentMethodOn,
} from '../../selectors/configSelectors';

const SalesChannelNotification = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const showPopupMessage = modalProps => dispatch(
    openModal({
      modalType: 'MESSAGE_MODAL',
      modalProps,
    }),
  );

  const isActive = useSelector(state => isSalesChannelActive(state));
  const isFulfillmentMethodOn = useSelector(state => isSalesChannelFulfillmentMethodOn(state));

  const checkAndShowSalesChannelNotificationIfNeeded = () => {
    if (open) return null;

    if (!isActive) {
      showPopupMessage({
        message: 'This online menu isn’t active. Please contact the dispensary for assistance.',
      });
      setOpen(true);
      return null;
    }

    if (!isFulfillmentMethodOn) {
      showPopupMessage({
        message: 'This menu is read-only. To purchase these products, please visit or contact the dispensary.',
      });
      setOpen(true);
    }
  };

  return (
    <React.Fragment>
      {checkAndShowSalesChannelNotificationIfNeeded()}
    </React.Fragment>
  );
};

export default React.memo(SalesChannelNotification, (props, nextProps) => props === nextProps);



// WEBPACK FOOTER //
// ./src/components/SalesChannelNotification/sales_channel_notification.jsx